<template>
  <v-container id="verifikasi-momen" fluid tag="section" class="vm-page">
    <base-material-card color="#018C74" icon="mdi-image-check-outline" class="vm-card">
      <template v-slot:heading>
        <div class="display-1 font-weight-black white--text">VERIFIKASI MOMEN</div>
        <div class="subtitle-2 white--text opacity-7">
          Periksa momen kiriman masyarakat sebelum tayang di galeri
        </div>
      </template>

      <!-- Filter status -->
      <v-row align="center" dense class="mt-2">
        <v-col cols="12" md="8">
          <v-chip-group
            v-model="filterStatus"
            mandatory
            active-class="vm-chip-active"
            @change="muatData"
          >
            <v-chip
              v-for="s in opsiStatus"
              :key="s.value"
              :value="s.value"
              small
              outlined
            >
              {{ s.text }}
              <v-chip
                v-if="s.value === 'menunggu' && jumlah"
                x-small
                color="#CFA22D"
                class="ml-2 white--text"
              >
                {{ jumlah }}
              </v-chip>
            </v-chip>
          </v-chip-group>
        </v-col>
        <v-col cols="12" md="4" class="text-md-right">
          <v-btn small text color="#018C74" class="text-capitalize" @click="muatData">
            <v-icon left small>mdi-refresh</v-icon>
            Muat ulang
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="daftar"
        :loading="loading"
        no-data-text="Tidak ada pengajuan"
        class="vm-table"
      >
        <template v-slot:item.judul_momen="{ item }">
          <div class="font-weight-bold">{{ item.judul_momen }}</div>
          <div class="caption grey--text text--darken-1">
            {{ item.nama_pengirim || "Anonim" }}
          </div>
        </template>
        <template v-slot:item.tanggal_ambil="{ item }">
          {{ tanggalSaja(item.tanggal_ambil) }}
        </template>
        <template v-slot:item.foto="{ item }">
          <div class="d-flex align-center">
            <img
              v-for="(f, i) in item.foto.slice(0, 3)"
              :key="i"
              :src="urlMedia(f)"
              class="vm-thumb mr-1"
              alt=""
              @click="zoom(f)"
            />
            <span v-if="item.foto.length > 3" class="caption ml-1">
              +{{ item.foto.length - 3 }}
            </span>
            <span v-if="!item.foto.length" class="caption">-</span>
          </div>
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ tanggal(item.created_at) }}
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip x-small label outlined :color="warnaStatus(item.status)">
            {{ item.status.toUpperCase() }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            small
            depressed
            color="#018C74"
            class="white--text text-capitalize"
            @click="buka(item)"
          >
            {{ item.status === "menunggu" ? "Periksa" : "Lihat" }}
          </v-btn>
          <v-btn
            v-if="item.status !== 'menunggu'"
            icon
            small
            color="#ff5252"
            @click="hapus(item)"
          >
            <v-icon small>mdi-trash-can-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </base-material-card>

    <!-- ================= DIALOG PERIKSA ================= -->
    <v-dialog v-model="dlg" max-width="860" scrollable persistent>
      <v-card v-if="mf" class="vm-dialog">
        <v-card-title class="vm-dialog-head">
          <div>
            <div class="title font-weight-black">
              {{ bisaEdit ? "Periksa Momen" : "Detail Momen" }}
            </div>
            <div class="caption grey--text text--darken-1">
              Dikirim {{ tanggal(mf.created_at) }}
              <v-chip x-small label outlined class="ml-2" :color="warnaStatus(mf.status)">
                {{ mf.status.toUpperCase() }}
              </v-chip>
            </div>
          </div>
          <v-spacer />
          <v-btn icon :disabled="menyimpan" @click="tutup"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>

        <v-divider />

        <v-card-text class="pt-4">
          <v-row>
            <!-- Foto -->
            <v-col cols="12" md="6">
              <div class="vm-label">
                FOTO
                <span v-if="bisaEdit">
                  &middot; centang yang ditayangkan ({{ fotoDipakai.length }}/{{
                    mf.foto.length
                  }})
                </span>
              </div>
              <div class="vm-grid">
                <div
                  v-for="f in mf.foto"
                  :key="f"
                  class="vm-grid-item"
                  :class="{ 'vm-grid-item--off': bisaEdit && !fotoDipakai.includes(f) }"
                >
                  <img :src="urlMedia(f)" alt="" @click="zoom(f)" />
                  <v-checkbox
                    v-if="bisaEdit"
                    v-model="fotoDipakai"
                    :value="f"
                    dense
                    hide-details
                    color="#018C74"
                    class="vm-grid-check"
                  />
                </div>
              </div>
              <div v-if="!mf.foto.length" class="caption">Tidak ada foto</div>
              <div
                v-if="bisaEdit && fotoDipakai.length < mf.foto.length"
                class="caption mt-2 orange--text text--darken-3"
              >
                Foto yang tidak dicentang akan dihapus dari server saat disetujui.
              </div>
            </v-col>

            <!-- Data -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="mf.judul_momen"
                label="Judul momen"
                outlined
                dense
                maxlength="255"
                :readonly="!bisaEdit"
              />
              <v-textarea
                v-model="mf.deskripsi"
                label="Deskripsi"
                outlined
                dense
                rows="4"
                auto-grow
                maxlength="2000"
                :readonly="!bisaEdit"
              />
              <v-text-field
                v-model="tanggalForm"
                type="date"
                label="Tanggal momen"
                outlined
                dense
                :readonly="!bisaEdit"
              />
              <v-alert
                v-if="bisaEdit && tanggalLama"
                dense
                text
                type="warning"
                class="caption"
              >
                Tanggal lebih dari 6 bulan lalu &mdash; momen akan tersimpan tetapi
                <b>tidak tampil</b> di galeri.
              </v-alert>

              <div class="vm-label mt-1">PENGIRIM</div>
              <div class="body-2">
                {{ mf.nama_pengirim || "Anonim" }}
                <span v-if="mf.kontak_pengirim" class="grey--text text--darken-1">
                  &middot; {{ mf.kontak_pengirim }}
                </span>
              </div>

              <v-textarea
                v-model="catatan"
                :label="
                  bisaEdit
                    ? 'Catatan admin (opsional, wajib saat menolak sebaiknya diisi alasan)'
                    : 'Catatan admin'
                "
                outlined
                dense
                rows="2"
                auto-grow
                maxlength="500"
                class="mt-4"
                :readonly="!bisaEdit"
              />
              <div
                v-if="!bisaEdit && mf.verified_at"
                class="caption grey--text text--darken-1"
              >
                Diverifikasi {{ tanggal(mf.verified_at) }} oleh
                {{ mf.verified_by || "-" }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-btn text class="text-capitalize" :disabled="menyimpan" @click="tutup"
            >Tutup</v-btn
          >
          <v-spacer />
          <template v-if="bisaEdit">
            <v-btn
              outlined
              color="#ff5252"
              class="text-capitalize"
              :disabled="menyimpan"
              @click="tolak"
            >
              <v-icon left small>mdi-close-circle-outline</v-icon>
              Tolak
            </v-btn>
            <v-btn
              depressed
              color="#018C74"
              class="white--text text-capitalize"
              :loading="menyimpan"
              :disabled="menyimpan || !fotoDipakai.length"
              @click="setujui"
            >
              <v-icon left small>mdi-check-circle-outline</v-icon>
              Setujui &amp; Tayangkan
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Zoom foto -->
    <v-dialog v-model="dlgZoom" max-width="960">
      <v-card class="vm-zoom">
        <v-img :src="urlMedia(zoomFile)" contain max-height="86vh" />
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snack.show" :color="snack.color" timeout="3500" top right>
      {{ snack.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";

const BASE_URL = "https://berkah.bondowosokab.go.id:5500";
const API_KEY = "7039338ec2fa8ac649760ddd8404b711b207479377c846d41d5d24b7b21beb97";
const authHeaders = { headers: { "Bondowoso-Berkah": API_KEY } };

const unwrap = (res) => (res.data.response ? res.data.response.data : res.data.data);

const pad = (n) => String(n).padStart(2, "0");
const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export default {
  name: "VerifikasiMomen",
  data: () => ({
    filterStatus: "menunggu",
    opsiStatus: [
      { text: "Menunggu", value: "menunggu" },
      { text: "Disetujui", value: "disetujui" },
      { text: "Ditolak", value: "ditolak" },
      { text: "Semua", value: "semua" },
    ],
    loading: false,
    menyimpan: false,
    jumlah: 0,
    userData: null,

    daftar: [],
    headers: [
      { text: "Momen", value: "judul_momen" },
      { text: "Tanggal momen", value: "tanggal_ambil" },
      { text: "Foto", value: "foto", sortable: false },
      { text: "Dikirim", value: "created_at" },
      { text: "Status", value: "status", align: "center" },
      { text: "Aksi", value: "actions", align: "end", sortable: false },
    ],

    dlg: false,
    mf: null,
    tanggalForm: "",
    fotoDipakai: [],
    catatan: "",

    dlgZoom: false,
    zoomFile: null,
    snack: { show: false, text: "", color: "success" },
  }),

  computed: {
    bisaEdit() {
      return !!this.mf && this.mf.status === "menunggu";
    },
    tanggalLama() {
      if (!this.tanggalForm) return false;
      const batas = new Date();
      batas.setMonth(batas.getMonth() - 6);
      return this.tanggalForm < ymd(batas);
    },
  },

  mounted() {
    const raw = localStorage.getItem("userData");
    if (raw) {
      try {
        this.userData = JSON.parse(raw);
      } catch (e) {
        this.userData = null;
      }
    }
    this.muatData();
  },

  methods: {
    // ---------- util ----------
    notif(text, color = "success") {
      this.snack = { show: true, text, color };
    },
    pesanError(e, fallback) {
      const r = e && e.response && e.response.data;
      return (r && ((r.response && r.response.message) || r.message)) || fallback;
    },
    namaAdmin() {
      return (this.userData && (this.userData.nama || this.userData.username)) || "admin";
    },
    tanggal(v) {
      if (!v) return "-";
      return new Date(v).toLocaleString("id-ID", {
        dateStyle: "medium",
        timeStyle: "short",
      });
    },
    tanggalSaja(v) {
      if (!v) return "-";
      return new Date(`${this.keYmd(v)}T00:00:00`).toLocaleDateString("id-ID", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    // tanggal dari API bisa "YYYY-MM-DD" atau ISO penuh -> "YYYY-MM-DD" (waktu lokal)
    keYmd(v) {
      if (!v) return "";
      if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return v;
      return ymd(new Date(v));
    },
    warnaStatus(s) {
      return s === "disetujui" ? "#018C74" : s === "ditolak" ? "#ff5252" : "#CFA22D";
    },
    urlMedia(n) {
      if (!n) return "";
      if (/^https?:\/\//i.test(n)) return n;
      return `${BASE_URL}/uploads/${String(n).replace(/^\/+/, "")}`;
    },
    zoom(f) {
      this.zoomFile = f;
      this.dlgZoom = true;
    },

    // ---------- data ----------
    async muatJumlah() {
      try {
        const res = await axios.get(
          `${BASE_URL}/master/temporary-momen/count`,
          authHeaders
        );
        this.jumlah = (unwrap(res) || {}).momen || 0;
      } catch (e) {
        console.error(e);
      }
    },
    async muatData() {
      this.loading = true;
      try {
        const res = await axios.get(`${BASE_URL}/master/temporary-momen`, {
          ...authHeaders,
          params: this.filterStatus === "semua" ? {} : { status: this.filterStatus },
        });
        this.daftar = unwrap(res) || [];
      } catch (e) {
        this.notif(this.pesanError(e, "Gagal memuat data"), "error");
      } finally {
        this.loading = false;
        this.muatJumlah();
      }
    },

    // ---------- dialog ----------
    buka(item) {
      this.mf = { ...item, foto: item.foto || [] };
      this.tanggalForm = this.keYmd(item.tanggal_ambil);
      this.fotoDipakai = [...this.mf.foto];
      this.catatan = item.catatan_admin || "";
      this.dlg = true;
    },
    tutup() {
      if (this.menyimpan) return;
      this.dlg = false;
    },

    async setujui() {
      if (!this.fotoDipakai.length) {
        this.notif("Pilih minimal 1 foto", "warning");
        return;
      }
      if (!this.mf.judul_momen || this.mf.judul_momen.trim().length < 3) {
        this.notif("Judul momen minimal 3 karakter", "warning");
        return;
      }
      this.menyimpan = true;
      try {
        await axios.put(
          `${BASE_URL}/master/temporary-momen/${this.mf.id}/setujui`,
          {
            judul_momen: this.mf.judul_momen,
            deskripsi: this.mf.deskripsi,
            tanggal_ambil: this.tanggalForm,
            foto_dipakai: this.fotoDipakai,
            catatan_admin: this.catatan,
            verified_by: this.namaAdmin(),
          },
          authHeaders
        );
        this.notif("Momen disetujui dan ditayangkan");
        this.dlg = false;
        this.muatData();
      } catch (e) {
        this.notif(this.pesanError(e, "Gagal menyetujui momen"), "error");
      } finally {
        this.menyimpan = false;
      }
    },

    async tolak() {
      if (!confirm("Tolak momen ini?")) return;
      this.menyimpan = true;
      try {
        await axios.put(
          `${BASE_URL}/master/temporary-momen/${this.mf.id}/tolak`,
          { catatan_admin: this.catatan, verified_by: this.namaAdmin() },
          authHeaders
        );
        this.notif("Momen ditolak");
        this.dlg = false;
        this.muatData();
      } catch (e) {
        this.notif(this.pesanError(e, "Gagal menolak momen"), "error");
      } finally {
        this.menyimpan = false;
      }
    },

    async hapus(item) {
      if (
        !confirm(
          `Hapus arsip "${item.judul_momen}"? Foto yang tidak dipakai momen tayang ikut terhapus.`
        )
      )
        return;
      try {
        await axios.delete(`${BASE_URL}/master/temporary-momen/${item.id}`, authHeaders);
        this.notif("Arsip dihapus");
        this.muatData();
      } catch (e) {
        this.notif(this.pesanError(e, "Gagal menghapus"), "error");
      }
    },
  },
};
</script>

<style scoped>
/* =====================================================
   VERIFIKASI MOMEN — MODERN BONDOWOSO BERKAH
   Vue 2 + Vuetify 2
   Base: #018C74 | Gold: #CFA22D
   ===================================================== */

.vm-page {
  padding: 20px 12px 32px !important;
  background: transparent !important;
}

/* Kartu utama */
.vm-card {
  background: #fff !important;
  border: 1px solid #e5eeeb !important;
  border-radius: 18px !important;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(19, 60, 50, 0.055) !important;
}

.vm-card .v-card__text {
  padding: 20px 24px 24px !important;
}

.vm-card .display-1 {
  font-size: 22px !important;
  line-height: 1.4 !important;
  letter-spacing: -0.45px !important;
}

.vm-card .subtitle-2 {
  font-size: 13px !important;
  line-height: 1.7 !important;
  opacity: 0.9;
}

/* Filter status */
.vm-card .v-chip-group {
  padding: 4px 0 !important;
}

.vm-card .v-chip-group > .v-chip {
  min-height: 32px;
  padding: 0 12px !important;
  border: 1px solid #e1eae7 !important;
  border-radius: 9px !important;
  background: #fff !important;
  color: #657570 !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
  transition: all 0.2s ease;
}

.vm-card .v-chip-group > .v-chip.v-chip--active,
.vm-card .v-chip-group > .vm-chip-active {
  color: #018c74 !important;
  background: rgba(1, 140, 116, 0.09) !important;
  border-color: rgba(1, 140, 116, 0.35) !important;
}

/* Angka jumlah pengajuan */
.vm-card .v-chip .v-chip {
  min-height: 19px !important;
  padding: 0 6px !important;
  border: none !important;
  border-radius: 6px !important;
  font-size: 10px !important;
}

/* Tombol muat ulang */
.vm-card .v-btn {
  border-radius: 9px !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
}

.vm-card .v-btn--text {
  min-height: 34px;
}

.vm-card .v-btn .v-icon {
  transition: transform 0.2s ease;
}

.vm-card .v-btn:hover .v-icon {
  transform: rotate(15deg);
}

/* Tabel */
.vm-table {
  border: 1px solid #e6eeea !important;
  border-radius: 13px !important;
  background: #fff !important;
  overflow: hidden;
}

.vm-table .v-data-table__wrapper {
  overflow-x: auto !important;
}

.vm-table table {
  border-collapse: separate !important;
  border-spacing: 0 !important;
}

.vm-table thead th {
  height: 48px !important;
  padding: 0 16px !important;
  background: #f5f9f7 !important;
  color: #49665e !important;
  font-size: 11px !important;
  font-weight: 800 !important;
  text-transform: uppercase;
  letter-spacing: 0.45px;
  white-space: nowrap;
  border-bottom: 1px solid #e3eeea !important;
}

.vm-table tbody tr {
  transition: background 0.18s ease;
}

.vm-table tbody tr:hover {
  background: #f6fbf9 !important;
}

.vm-table tbody td {
  padding: 13px 16px !important;
  color: #354741 !important;
  font-size: 12px !important;
  border-bottom: 1px solid #edf2f0 !important;
}

.vm-table tbody tr:last-child td {
  border-bottom: none !important;
}

.vm-table .v-data-footer {
  background: #fcfdfc;
  border-top: 1px solid #e8efec !important;
  font-size: 12px;
}

/* Thumbnail tabel */
.vm-thumb {
  width: 44px !important;
  height: 44px !important;
  flex-shrink: 0;
  object-fit: cover;
  border: 1px solid #e2ebe7 !important;
  border-radius: 10px !important;
  cursor: zoom-in;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.vm-thumb:hover {
  transform: scale(1.06);
  box-shadow: 0 4px 12px rgba(1, 140, 116, 0.18);
}

/* Tombol aksi tabel */
.vm-table .v-btn {
  min-width: 68px !important;
  padding: 0 13px !important;
  border-radius: 8px !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  box-shadow: none !important;
}

.vm-table .v-btn--icon {
  min-width: 30px !important;
  width: 30px !important;
  height: 30px !important;
  padding: 0 !important;
}

/* Chip status */
.vm-table .v-chip,
.vm-dialog-head .v-chip {
  border-radius: 6px !important;
  font-size: 10px !important;
  font-weight: 800 !important;
  letter-spacing: 0.35px !important;
}

/* Dialog verifikasi */
.vm-dialog {
  background: #fff !important;
  border-radius: 18px !important;
  overflow: hidden !important;
  box-shadow: 0 24px 80px rgba(18, 49, 42, 0.2) !important;
}

.vm-dialog-head {
  display: flex;
  align-items: flex-start !important;
  gap: 12px;
  padding: 22px 24px !important;
  background: linear-gradient(135deg, #f4faf7 0%, #ffffff 100%);
  border-bottom: 1px solid #e6efeb;
}

.vm-dialog-head .title {
  color: #203d34;
  font-size: 20px !important;
  line-height: 1.45;
  letter-spacing: -0.3px !important;
}

.vm-dialog-head .caption {
  margin-top: 5px;
  color: #75847e !important;
  font-size: 12px !important;
  line-height: 1.8;
}

.vm-dialog > .v-card__text {
  padding: 22px 24px !important;
}

.vm-dialog > .v-card__actions {
  gap: 8px;
  background: #fbfdfc;
  border-top: 1px solid #e9efec;
}

.vm-dialog > .v-divider {
  border-color: #e8efec !important;
}

/* Label foto dan informasi */
.vm-label {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 12px;
  color: #49665e !important;
  font-size: 11px !important;
  font-weight: 800 !important;
  letter-spacing: 0.8px;
}

/* Galeri foto */
.vm-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 12px;
}

.vm-grid-item {
  position: relative;
  min-width: 0;
  overflow: hidden;
  border: 1px solid #e2ebe6 !important;
  border-radius: 12px !important;
  background: #fff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.vm-grid-item:hover {
  border-color: rgba(1, 140, 116, 0.5) !important;
  box-shadow: 0 5px 16px rgba(1, 140, 116, 0.08);
}

.vm-grid-item img {
  display: block;
  width: 100%;
  height: 120px !important;
  object-fit: cover;
  cursor: zoom-in;
  background: #f1f5f3;
  transition: transform 0.25s ease;
}

.vm-grid-item:hover img {
  transform: scale(1.025);
}

/* Checkbox pilihan foto */
.vm-grid-check {
  position: absolute;
  top: 5px !important;
  left: 5px !important;
  z-index: 2;
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.vm-grid-check .v-input__slot {
  margin: 0 !important;
}

.vm-grid-check .v-input--selection-controls__input {
  margin: 0 !important;
}

.vm-grid-check ::v-deep .v-input--selection-controls__ripple {
  background: rgba(1, 140, 116, 0.12);
}

/* Foto yang tidak dipilih */
.vm-grid-item--off {
  opacity: 0.48;
  border-color: #e7eae8 !important;
  background: #f6f8f7;
}

.vm-grid-item--off img {
  filter: grayscale(35%);
}

/* Form dialog */
.vm-dialog .v-input {
  font-size: 13px;
}

.vm-dialog .v-input__control > .v-input__slot {
  border-radius: 10px !important;
}

.vm-dialog .v-label {
  font-size: 13px;
}

.vm-dialog .v-text-field--outlined fieldset,
.vm-dialog .v-textarea--outlined fieldset {
  border-color: #dce7e2 !important;
}

.vm-dialog .v-input--is-focused fieldset {
  border-color: #018c74 !important;
}

.vm-dialog .v-textarea textarea {
  line-height: 1.7;
}

.vm-dialog .v-alert {
  border-radius: 10px !important;
  font-size: 12px;
  line-height: 1.7;
}

/* Tombol aksi dialog */
.vm-dialog .v-card__actions .v-btn {
  min-height: 38px;
  border-radius: 9px !important;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0 !important;
}

.vm-dialog .v-btn--text {
  padding: 0 14px;
}

/* Preview foto */
.vm-zoom {
  padding: 8px;
  overflow: hidden;
  background: #10231f !important;
  border-radius: 14px !important;
}

.vm-zoom .v-image {
  border-radius: 8px;
}

/* Responsif tablet */
@media (max-width: 960px) {
  .vm-page {
    padding: 12px !important;
  }

  .vm-card .v-card__text {
    padding: 16px !important;
  }

  .vm-card .display-1 {
    font-size: 19px !important;
  }

  .vm-dialog-head {
    padding: 18px !important;
  }

  .vm-dialog > .v-card__text {
    padding: 18px !important;
  }
}

/* Responsif ponsel */
@media (max-width: 600px) {
  .vm-page {
    padding: 8px !important;
  }

  .vm-card {
    border-radius: 13px !important;
  }

  .vm-card .v-card__text {
    padding: 12px !important;
  }

  .vm-card .display-1 {
    font-size: 17px !important;
  }

  .vm-card .subtitle-2 {
    font-size: 11px !important;
  }

  .vm-card .v-chip-group {
    overflow-x: auto;
    flex-wrap: nowrap;
  }

  .vm-card .v-chip-group > .v-chip {
    flex-shrink: 0;
    font-size: 10px !important;
  }

  .vm-card .v-chip-group > .v-chip .v-chip {
    font-size: 9px !important;
  }

  .vm-table tbody td {
    padding: 10px 12px !important;
  }

  .vm-dialog {
    border-radius: 0 !important;
  }

  .vm-dialog-head {
    padding: 15px !important;
    gap: 6px;
  }

  .vm-dialog-head .title {
    font-size: 17px !important;
  }

  .vm-dialog-head .caption {
    font-size: 11px !important;
  }

  .vm-dialog > .v-card__text {
    padding: 14px !important;
  }

  .vm-dialog > .v-card__actions {
    padding: 12px !important;
    flex-wrap: wrap;
  }

  .vm-dialog .v-card__actions .v-btn {
    font-size: 11px;
  }

  .vm-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 9px;
  }

  .vm-grid-item img {
    height: 125px !important;
  }

  .vm-zoom {
    border-radius: 0 !important;
  }
}
</style>
